import React from "react";
import howitworks from "@/assets/images/howitworks.png";

const HowItWorksSections = () => {
  return (
    <section className="py-12 px-6 md:px-16 w-full">
      <div className="flex flex-col md:flex-row gap-12 items-center mt-10">
        {/* Etapas à esquerda */}
        <div className="space-y-10 px-30 w-2/3">
          <h2 className="!text-3xl md:text-4xl !font-bold !mb-3 text-[#356405]">
            Como funciona?
          </h2>
          {/* Etapa 1 */}
          <div className="flex flex-col items-start">
            <h3 className="!text-2xl !font-semibold text-gray-800">
              01. Cadastro da Propriedade
            </h3>
            <p className="text-lg">
              O primeiro passo consiste no cadastro da sua propriedade em nossa
              plataforma. Nessa etapa, é necessário o envio dos documentos
              exigidos para análise. Simultaneamente, disponibilizamos um
              contrato detalhado para garantir que todas as partes compreendam
              os trâmites envolvidos no processo.
            </p>
          </div>

          {/* Etapa 2 */}
          <div className="flex flex-col items-start">
            <h3 className="!text-2xl !font-semibold text-gray-800">
              02. Certificação da Área
            </h3>
            <p className="text-lg">
              Após a análise documental, realizamos a certificação da área. Essa
              fase inclui a validação técnica e a quantificação dos créditos de
              carbono disponíveis na propriedade, conforme critérios
              reconhecidos.
            </p>
          </div>

          {/* Etapa 3 */}
          <div className="flex flex-col items-start">
            <h3 className="!text-2xl !font-semibold text-gray-800">
              03. Monitoramento Ambiental
            </h3>
            <p className="text-lg">
              Com a área certificada, iniciamos o monitoramento contínuo via
              satélite. Essa vigilância tem como objetivo detectar possíveis
              ocorrências de desmatamento ou incêndios, assegurando a
              integridade ambiental da propriedade.
            </p>
          </div>

          {/* Etapa 4 */}
          <div className="flex flex-col items-start">
            <h3 className="!text-2xl !font-semibold text-gray-800">
              04. Segurança nas Transações
            </h3>
            <p className="text-lg">
              Por fim, com a área certificada e monitorada, garantimos a
              segurança jurídica e ambiental necessária para a comercialização
              dos créditos de carbono, promovendo confiança e transparência em
              cada transação.
            </p>
          </div>
        </div>

        {/* Imagem à direita */}
        <div>
          <img
            src={`${howitworks}`}
            alt="Fluxo do processo"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSections;
